import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { userSelector } from '@selectors';
import { useSelector } from '@hooks';

import { SwitchAccountModal } from '@components/Modals';
import { Modal } from '@components/Shared';

export const OrganizationInviteSwitchAccount: React.FC = () => {
  const { email: userEmail } = useSelector(userSelector);

  const [searchParams, setSearchParams] = useSearchParams();

  const [email, setEmail] = useState('');

  const resetEmailSearchParam = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  useEffect(() => {
    const email = searchParams.get('login_hint');

    if (email && userEmail !== email) {
      setEmail(email);
    }
  }, [userEmail, searchParams]);

  if (email) {
    return (
      <Modal
        defaultOpen
        onClose={resetEmailSearchParam}
        content={<SwitchAccountModal />}
      />
    );
  }

  return null;
};
